/// <amd-module name="Build/Admin/Common/Components/JobsFilterBar" />
import * as React from "react";

import { DropdownFilterBarItem } from "VSSUI/Dropdown";
import { FilterBar } from "VSSUI/FilterBar";
import { IListSelection } from "VSSUI/List";
import { IListBoxItem } from "VSSUI/ListBox";
import { KeywordFilterBarItem } from "VSSUI/TextFilterBarItem";
import { DropdownMultiSelection } from "VSSUI/Utilities/DropdownSelection";
import { Filter } from "VSSUI/Utilities/Filter";

import { AgentDefinition } from "PoolProvider/Shared/Contracts/PoolProviderShared";

import { TaskAgent } from "DistributedTask/Client/Contracts/TaskAgent";

import { ITeamProject } from "TFS/Services/TfsProjectService";

import { AgentColumnStyle } from "Build/Admin/Common/Components/JobsList";
import { FilterKeys } from "Build/Admin/Common/Constants";

import * as Resources from "Build/Admin/Common/Resources";

export interface IJobsFilterBarProps {
    agentColumnStyle: AgentColumnStyle;
    agents: TaskAgent[];
    agentDefinitions: AgentDefinition[];
    projects: ITeamProject[];
    filter: Filter;
    onFilterToggled(): void;
}

export class JobsFilterBar extends React.Component<IJobsFilterBarProps> {
    private agentSelection: IListSelection;
    private agentSpecSelection: IListSelection;
    private projectSelection: IListSelection;

    constructor(props: IJobsFilterBarProps) {
        super(props);
        this.agentSelection = new DropdownMultiSelection();
        this.agentSpecSelection = new DropdownMultiSelection();
        this.projectSelection = new DropdownMultiSelection();
    }

    public render(): JSX.Element {
        return (
            <FilterBar
                className="bolt-filterbar-white depth-8 flex-noshrink"
                filter={this.props.filter}
                onDismissClicked={this.props.onFilterToggled}>
                <KeywordFilterBarItem filterItemKey={FilterKeys.Keyword} filter={this.props.filter} />
                <DropdownFilterBarItem
                    filterItemKey={FilterKeys.Project}
                    filter={this.props.filter}
                    items={this._getProjectNames()}
                    selection={this.projectSelection}
                    placeholder={Resources.Project} />
                {
                    this.props.agentColumnStyle === AgentColumnStyle.Agent &&
                    <DropdownFilterBarItem
                        noItemsText={Resources.NoAgentsAvailable}
                        filterItemKey={FilterKeys.Agent}
                        filter={this.props.filter}
                        items={this._getAgentNames()}
                        selection={this.agentSelection}
                        placeholder={Resources.Agent} />
                }
                {
                    this.props.agentColumnStyle === AgentColumnStyle.AgentSpec &&
                    <DropdownFilterBarItem
                        filterItemKey={FilterKeys.AgentSpec}
                        filter={this.props.filter}
                        items={this._getAgentSpecNames()}
                        selection={this.agentSpecSelection}
                        placeholder={Resources.AgentSpecification} />
                }
            </FilterBar>
        );
    }

    private _getProjectNames = (): IListBoxItem[] => {
        return this.props.projects.map(project => {
            return { text: project.name, id: project.id } as IListBoxItem;
        });
    }

    private _getAgentNames = (): string[] => {
        return this.props.agents.map(agent => agent.name);
    }

    private _getAgentSpecNames = (): string[] => {
        return this.props.agentDefinitions.map(agentDef => agentDef.identifier);
    }
}
